export const defaultSecondaryStyles = {
  default: {
    backgroundColor:
      "var(--theme-website-secondary-button-default-background-color)",
    borderColor: "var(--theme-website-secondary-button-default-border-color)",
    borderRadius: {
      border_left_top_radius:
        "var(--theme-website-secondary-button-default-border-left-top-radius)",
      border_left_bottom_radius:
        "var(--theme-website-secondary-button-default-border-left-bottom-radius)",
      border_right_top_radius:
        "var(--theme-website-secondary-button-default-border-right-top-radius)",
      border_right_bottom_radius:
        "var(--theme-website-secondary-button-default-border-right-bottom-radius)",
    },
    borderWidth: "var(--theme-website-secondary-button-default-border-width)",
    color: "var(--theme-website-secondary-button-default-text-color)",
    fontSize: "var(--theme-website-secondary-button-default-font-size)",
    fontStyle: "normal",
    fontWeight: "var(--theme-website-secondary-button-default-font-weight)",
    lineHeight: "var(--theme-website-secondary-button-default-line-height)",
    textAlign: "left",
    textDecoration: "none",
    textTransform: "none",
  },
  hover: {
    backgroundColor:
      "var(--theme-website-secondary-button-hover-background-color)",
    borderColor: "var(--theme-website-secondary-button-hover-border-color)",
    borderRadius: {
      border_left_top_radius:
        "var(--theme-website-secondary-button-hover-border-left-top-radius)",
      border_left_bottom_radius:
        "var(--theme-website-secondary-button-hover-border-left-bottom-radius)",
      border_right_top_radius:
        "var(--theme-website-secondary-button-hover-border-right-top-radius)",
      border_right_bottom_radius:
        "var(--theme-website-secondary-button-hover-border-right-bottom-radius)",
    },
    borderWidth: "var(--theme-website-secondary-button-hover-border-width)",
    color: "var(--theme-website-secondary-button-hover-text-color)",
    fontSize: "var(--theme-website-secondary-button-hover-font-size)",
    fontStyle: "normal",
    fontWeight: "var(--theme-website-secondary-button-hover-font-weight)",
    lineHeight: "var(--theme-website-secondary-button-hover-line-height)",
    textAlign: "left",
    textDecoration: "none",
    textTransform: "none",
  },
  sizing: {
    width: "100px",
    height: "40px",
    minWidth: "100px",
    minHeight: "40px",
    maxWidth: "100px",
    maxHeight: "40px",
  },
  padding: {
    paddingTop: "var(--theme-website-secondary-button-padding-top)",
    paddingBottom: "var(--theme-website-secondary-button-padding-bottom)",
    paddingLeft: "var(--theme-website-secondary-button-padding-left)",
    paddingRight: "var(--theme-website-secondary-button-padding-right)",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
